import React, { useRef, useState, useEffect } from "react"
import { gsap } from "gsap/dist/gsap"
import { Cta } from "../cta/Cta"

import * as s from "./Carousel.module.scss"

export const Carousel = ({ data, styleType, className }) => {
  const { slides } = data
  const [activeSlide, setActiveSlide] = useState(0)
  const _progress = useRef(null)
  const tl = new gsap.timeline()
  const hasMultiSlides = slides.length > 1

  useEffect(() => {
    if (!hasMultiSlides) return

    const timer = setTimeout(() => {
      setActiveSlide(old => {
        if (activeSlide >= slides.length - 1) {
          return 0
        } else {
          return old + 1
        }
      })
      tl.to(_progress.current, 0.4, {
        scaleX: 1,
      })
        .set(_progress.current, {
          transformOrigin: "right",
        })
        .to(_progress.current, 0.4, {
          scaleX: 0,
        })

        .set(_progress.current, {
          scaleX: 0,
          transformOrigin: "left",
        })
        .to(_progress.current, 3.2, {
          scaleX: 0.9,
        })
    }, 4000)

    return () => clearTimeout(timer)
  }, [activeSlide])

  useEffect(() => {
    if (!hasMultiSlides) return
    tl.to(_progress.current, 4, {
      scaleX: 0.95,
    })
  }, [])

  return (
    <div
      className={`${s.Carousel} ${styleType === "BRAND" && s.Carousel__brand} ${
        className && className
      }`}
    >
      {slides.map((slide, i) => (
        <div
          key={`${slide.title}${i}`}
          className={`${s.Slide} ${activeSlide === i && s.Slide___active}`}
          style={
            slide.image
              ? {
                  backgroundImage: `url(${slide.image})`,
                }
              : {}
          }
        >
          <div
            className={`${s.Slide__content} ${
              styleType !== "BRAND" &&
              slide.title &&
              s.Slide__content___darkened
            }`}
          >
            {slide.title && <h4>{slide.title}</h4>}
            {slide.links && (
              <div className={s.Slide__links}>
                {slide.links.map((item, i) => {
                  if (!item.link) return <></>
                  return (
                    <Cta
                      key={`${item.link.title}${i}`}
                      title={item.link.title}
                      link={item.link.url}
                    />
                  )
                })}
              </div>
            )}
          </div>
        </div>
      ))}

      {hasMultiSlides && (
        <div className={s.Progress}>
          <div className={s.Progress__bar__progress} ref={_progress} />
          <div className={s.Progress__bar} />
          <div className={s.Progress__dots}>
            {slides.map((slide, i) => (
              <div
                key={`Slide${i}`}
                className={`${s.Progress__dots__dot} ${
                  activeSlide == i && s.Progress__dots__dot___active
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
